import { FollowOnRoundDTO } from './FollowOnRoundDTO';
import { ModelPerfPredict } from '../../utils/ModelPerfPredict';

export class FollowOnPortfolioDTO {
  uuid: string;
  name: string;
  companyUUID: string;
  currentCost: number;
  currentFmv: number;
  currentHolding: number;
  currentCompValue: number;
  rounds: FollowOnRoundDTO[] = [new FollowOnRoundDTO(), new FollowOnRoundDTO(), new FollowOnRoundDTO()];
  perfPredict: ModelPerfPredict = new ModelPerfPredict();
  areExitProbsValid: boolean;
}

export const FollowOnPortfolioDTOSorting = {
  byCompanyName: (p: FollowOnPortfolioDTO) => p.name,
  byCost: (p: FollowOnPortfolioDTO) => p.currentCost,
  byCurrentCompValue: (p: FollowOnPortfolioDTO) => p.currentCompValue,
};
